import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { ScrollToTop } from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import Welcome from "./pages/Welcome";
import About from "./pages/About";
import Ministries from "./pages/Ministries";
import SundaySchool from "./pages/SundaySchool";
import Gallery from "./pages/Gallery";
import PastoralMessage from "./pages/PastoralMessage";
import History from "./pages/History";
import Calendar from "./pages/Calendar";
import Contact from "./pages/Contact";
import Documents from "./pages/Documents";
import Images from "./pages/Images";
import DaycarePreschool from "./pages/DaycarePreschool";
import ContentPage from "./pages/ContentPage";

// Admin
import AdminDashboard from "./components/admin/AdminDashboard";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/about" element={<About />} />
            <Route path="/ministries" element={<Ministries />} />
            <Route path="/sunday-school" element={<SundaySchool />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/images" element={<Images />} />
            <Route path="/pastoral-message" element={<PastoralMessage />} />
            <Route path="/history" element={<History />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/daycare-preschool" element={<DaycarePreschool />} />
            <Route path="/bluemonkey" element={<AdminDashboard />} />
            <Route path="/page/:slug" element={<ContentPage />} />
            {/* Catch-all route for dynamic CMS pages with clean URLs */}
            <Route path="/:slug" element={<ContentPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
